import { FS_CLASSES } from '@calendly/ui/components/fullstory-privacy';
import { forwardRef, ReactNode } from 'react';

/** Desktop: nav + app bar + body row (content + optional side panel). */
const appShellCss = "a8v9cbb";
interface AppShellProps {
  children: ReactNode;
}

/**
 * Product-refresh shell: fills remaining viewport below `#shell-global-banner`.
 * Page scroll lives inside `CenterPanelContent`.
 * The body row (content + optional side panel) is a flex row managed by `AppLayout`.
 */
export const AppShell = forwardRef<HTMLDivElement, AppShellProps>(({
  children
}, ref) => <div ref={ref} id="app-shell" className={`${appShellCss} ${FS_CLASSES.UNMASK}`}>
    {children}
  </div>);
AppShell.displayName = 'AppShell';

require("./AppShell.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./AppShell.tsx");